export default __webpack_public_path__ + "static/media/panamilk.e25a87a3.png";